import React, { useState } from 'react';
import { Briefcase, CalendarOff, CalendarDays, Users } from 'lucide-react';

import TabIntervenciones from '../tecnico/TabIntervenciones';
import TabBloqueos from '../tecnico/TabBloqueos';
import TabCalendario from '../tecnico/TabCalendario';
import TabParticipantes from '../tecnico/TabParticipantes';

/**
 * PanelTecnico — pantalla del técnico con 3 tabs:
 *  - Mis intervenciones: lista de citas asignadas (cerrar, ver detalle)
 *  - Mis bloqueos: gestión de bloqueos personales (CRUD)
 *  - Mi calendario: vista cronológica de citas + bloqueos
 *
 * Ruta: /citas-tecnicas/panel-tecnico
 * Permiso: `intervenciones.miscitas.view` (mismo que el usuario final).
 */

const TABS = [
  { id: 'intervenciones', label: 'Mis intervenciones', icon: Briefcase },
  { id: 'bloqueos', label: 'Mis bloqueos', icon: CalendarOff },
  { id: 'calendario', label: 'Mi calendario', icon: CalendarDays },
  // 24/10: registrar una intervención hecha sin cita (o marcar la cita) y deshacerlo.
  { id: 'participantes', label: 'Personas de mis campañas', icon: Users },
];

export default function PanelTecnico() {
  const [activa, setActiva] = useState('intervenciones');

  return (
    // 3/11 · sin `max-w-5xl`: limitaba el panel entero (las cuatro pestañas) a 1024 px, y con «Hoy» y
    // «Próximas» en dos columnas ocupaba sólo la mitad izquierda. Ahora usa el ancho disponible, como
    // el resumen de la campaña; en móvil las columnas se apilan (TabIntervenciones, lg:grid-cols-2).
    <div className="px-4 sm:px-6 py-5 min-h-full w-full">
      <div className="mb-5">
        <h1 className="text-xl font-semibold text-slate-900">Panel del técnico</h1>
        <p className="text-sm text-slate-500 mt-1">
          Gestiona las intervenciones que tienes asignadas y tus bloqueos personales.
        </p>
      </div>

      {/* Tabs */}
      <div className="border-b border-slate-200 mb-4">
        <div className="flex gap-1">
          {TABS.map((t) => {
            const Icon = t.icon;
            const activo = activa === t.id;
            return (
              <button
                key={t.id}
                type="button"
                onClick={() => setActiva(t.id)}
                className={
                  'px-4 py-2 text-sm font-medium border-b-2 -mb-px transition-colors flex items-center gap-2 ' +
                  (activo
                    ? 'border-slate-900 text-slate-900'
                    : 'border-transparent text-slate-500 hover:text-slate-800 hover:border-slate-200')
                }
              >
                <Icon className="w-4 h-4" />
                {t.label}
              </button>
            );
          })}
        </div>
      </div>

      {/* Contenido de la tab activa */}
      <div>
        {activa === 'intervenciones' && <TabIntervenciones />}
        {activa === 'bloqueos' && <TabBloqueos />}
        {activa === 'calendario' && <TabCalendario />}
        {activa === 'participantes' && <TabParticipantes />}
      </div>
    </div>
  );
}
